module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row holder"
  }, [_c('div', {
    staticClass: "col-xs-6 col-xs-offset-1"
  }, [_c('h4', [_vm._v(" " + _vm._s(_vm.item.name) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.item.url
    }
  }, [_vm._v(" " + _vm._s(_vm.item.url) + " ")]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.item.description.substr(0, 120).replace(/<\/?[^>]+(>|$)/g, " ")) + "\n      "), (_vm.item.description.length > 120) ? _c('span', [_vm._v(" ... ")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.item.city) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-right"
  }, [_c('img', {
    attrs: {
      "src": _vm.item.photo
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e7fd2fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/vk.vue
// module id = 53
// module chunks = 0